import Work1 from '../../assets/work1.jpg';
import Work2 from '../../assets/work2.jpg';
import Work3 from '../../assets/work3.png';
import Work4 from '../../assets/work4.png';

export const projectsData = [
    {
        id: 1,
        image: Work1,
        title: 'GreenCart',
        link: 'https://greencart-murex-one.vercel.app'
    },
    {
        id: 2,
        image: Work2,
        title: 'QuickChat',
        link: 'https://chat-app-olive-seven-81.vercel.app'
    },
    {
        id: 3,
        image: Work3,
        title: 'QuickBlog',
        link: 'https://quick-blog-chi-six.vercel.app'
    },
    {
        id: 4,
        image: Work4,
        title: 'QuickShow',
        link: 'https://movie-ticket-booking-app-frontend-tau.vercel.app'
    }
]

